var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flowsSerlectContractAndProject" },
    [
      _c(
        "van-popup",
        {
          style: { width: "90%", backgroundColor: "#eae9e9" },
          attrs: {
            position: "right",
            "close-on-click-overlay": false,
            round: "",
          },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: { title: "请双击选择合同或项目", "left-text": "取消" },
            on: { "click-left": _vm.close },
          }),
          _c("van-search", {
            attrs: {
              placeholder: _vm.searchPromptText,
              "show-action": "",
              clearable: "",
              shape: "round",
            },
            on: { input: _vm.onSearch },
            scopedSlots: _vm._u(
              [
                _vm.tabType == "project"
                  ? {
                      key: "action",
                      fn: function () {
                        return [
                          _c("div", { on: { click: _vm.changeProjectMore } }, [
                            _vm._v(_vm._s(_vm.projectMoreTest)),
                          ]),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
          _c(
            "van-tabs",
            { attrs: { type: "card" }, on: { click: _vm.onClickTabs } },
            [
              _c(
                "van-tab",
                { attrs: { title: _vm.projectTabTest, name: "project" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "h-vh-70",
                      staticStyle: { "overflow-y": "auto" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "h-vh-70",
                          staticStyle: { "overflow-y": "auto" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "p-10" },
                            [
                              _c(
                                "van-pull-refresh",
                                {
                                  on: { refresh: _vm.onRefresh },
                                  model: {
                                    value: _vm.refreshing,
                                    callback: function ($$v) {
                                      _vm.refreshing = $$v
                                    },
                                    expression: "refreshing",
                                  },
                                },
                                [
                                  _c(
                                    "van-list",
                                    {
                                      staticClass: "p-l-20 p-r-20 p-b-20",
                                      attrs: {
                                        "immediate-check": false,
                                        error: _vm.error,
                                        finished: _vm.finished,
                                        "finished-text": "没有更多了",
                                      },
                                      on: {
                                        "update:error": function ($event) {
                                          _vm.error = $event
                                        },
                                        load: _vm.getProjectList,
                                      },
                                      model: {
                                        value: _vm.loading,
                                        callback: function ($$v) {
                                          _vm.loading = $$v
                                        },
                                        expression: "loading",
                                      },
                                    },
                                    _vm._l(
                                      _vm.projectList,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass:
                                              "bg-FF p-20 m-t-20 b-r-10",
                                            style: {
                                              border: item.activated
                                                ? "3px solid #F8B91A"
                                                : "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickItem(item)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex col-center row-between",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-1 font-30 cor-3E3A39 font-weight-600",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.projectName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "van-row",
                                              {
                                                staticClass: "m-t-10",
                                                attrs: {
                                                  type: "flex",
                                                  align: "center",
                                                },
                                              },
                                              [
                                                _c(
                                                  "van-col",
                                                  { attrs: { span: "10" } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cor-88 font-30",
                                                      },
                                                      [_vm._v("项目负责人")]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "van-col",
                                                  { attrs: { span: "14" } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cor-33 font-30 van-multi-ellipsis--l3",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.projectManagerName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "van-row",
                                              {
                                                staticClass: "m-t-10",
                                                attrs: {
                                                  type: "flex",
                                                  align: "center",
                                                },
                                              },
                                              [
                                                _c(
                                                  "van-col",
                                                  { attrs: { span: "10" } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cor-88 font-30",
                                                      },
                                                      [_vm._v("创建时间")]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "van-col",
                                                  { attrs: { span: "14" } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cor-33 font-30 van-multi-ellipsis--l3",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.createTime
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _c("van-tab", { attrs: { title: "合同", name: "contract" } }, [
                _c(
                  "div",
                  {
                    staticClass: "h-vh-70",
                    staticStyle: { "overflow-y": "auto" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "p-10" },
                      [
                        _c(
                          "van-pull-refresh",
                          {
                            on: { refresh: _vm.onRefresh },
                            model: {
                              value: _vm.refreshing,
                              callback: function ($$v) {
                                _vm.refreshing = $$v
                              },
                              expression: "refreshing",
                            },
                          },
                          [
                            _c(
                              "van-list",
                              {
                                staticClass: "p-l-20 p-r-20 p-b-20",
                                attrs: {
                                  "immediate-check": false,
                                  error: _vm.error,
                                  finished: _vm.finished,
                                  "finished-text": "没有更多了",
                                },
                                on: {
                                  "update:error": function ($event) {
                                    _vm.error = $event
                                  },
                                  load: _vm.getContractList,
                                },
                                model: {
                                  value: _vm.loading,
                                  callback: function ($$v) {
                                    _vm.loading = $$v
                                  },
                                  expression: "loading",
                                },
                              },
                              _vm._l(_vm.contractList, function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "bg-FF p-20 m-t-20 b-r-10",
                                    style: {
                                      border: item.activated
                                        ? "3px solid #F8B91A"
                                        : "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickItem(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex col-center row-between",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex-1 font-30 cor-3E3A39 font-weight-600",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.contractName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "van-row",
                                      {
                                        staticClass: "m-t-10",
                                        attrs: {
                                          type: "flex",
                                          align: "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "van-col",
                                          { attrs: { span: "10" } },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "cor-88 font-30" },
                                              [_vm._v("合同金额")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "van-col",
                                          { attrs: { span: "14" } },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cor-33 font-30 van-multi-ellipsis--l3",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.contractAmount
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "van-row",
                                      {
                                        staticClass: "m-t-10",
                                        attrs: {
                                          type: "flex",
                                          align: "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "van-col",
                                          { attrs: { span: "10" } },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "cor-88 font-30" },
                                              [_vm._v("签订客户")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "van-col",
                                          { attrs: { span: "14" } },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cor-33 font-30 van-multi-ellipsis--l3",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.customerCompanyName
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }